import React from 'react';
import { path } from 'ramda';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import ActionDescriptionField from 'components/cards/education/action/ActionDescriptionField';
import { DateField } from 'components/common/fields/DateTimeFields';
import ClassifierFields from 'components/common/fields/ClassifierFields';
import ActionVacancyLibObjList from './ActionVacancyLibObjList';

export const ActionVacancyCard = ({ item: { descriptions = [], state }, item }) => {
    const responsible = path(['responsibles', 0, 'text'], item);
    const publish = path(['date', 'publication'], item);
    const done = path(['date', 'done'], item);

    return (
        <div>
            <DefinitionHeader translate="common.general" iconType='info-outline' />
            <div className="panel-view">
                <DefinitionField
                    translate="education.actionVacancy.headers.responsible"
                    text={responsible}
                />
                <DefinitionField
                    translate="education.actionVacancy.headers.state"
                    text={state}
                />
                <DefinitionField translate="education.actionVacancy.card.publication">
                    <DateField date={publish} />
                </DefinitionField>
                <DefinitionField translate="education.actionVacancy.card.done">
                    <DateField date={done} />
                </DefinitionField>
            </div>

            <ClassifierFields classifiers={item.classifier} />
            <ActionDescriptionField descriptions={descriptions} />
            <ActionVacancyLibObjList objectList={item.libraryObjectList} />
        </div>
    );
}
